import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import gsap from 'gsap';

export default class BlockSlider {
	constructor(container) {
		const sliderEl = container.querySelector('.swiper');

		this.next = container.querySelector('[data-swiper-next]');
		this.prev = container.querySelector('[data-swiper-prev]');

		this.sliderLinks = container.querySelectorAll('[data-slider-links]');
		this.sliderBlockLinks = container.querySelectorAll('[data-slider-block-link]');
		this.sliderBlockLinks.forEach((linkElement) => {
			const linkElementIndex = parseInt(linkElement.getAttribute('data-slider-block-link'), 10);

			if (linkElementIndex === 0) {
				linkElement.classList.add('is-active');
			} else {
				linkElement.classList.remove('is-active');
			}

			linkElement.addEventListener('click', (e) => {
				e.preventDefault();

				if (this.swiper) {
					this.swiper.slideTo(linkElementIndex);

					this.sliderBlockLinks.forEach((link) => {
						if (link === linkElement) {
							link.classList.add('is-active');
						} else {
							link.classList.remove('is-active');
						}
					});
				}

				gsap.to(this.sliderLinks, {
					duration: 0.5,
					scrollTo: {
						x: linkElement,
						offsetX: window.innerWidth / 2 - linkElement.offsetWidth / 2,
						autoKill: false,
					},
				});
			});
		});

		const options = {
			slidesPerView: 1,
			spaceBetween: 17,
			initialSlide: 0,
			lazy: true,
			speed: 1000,
			keyboard: true,
			modules: [Navigation],

			a11y: {
				prevSlideMessage: 'Vorige slide',
				nextSlideMessage: 'Volgende slide',
			},

			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			breakpoints: {
				768: {
					spaceBetween: 72,
				},
			},
		};

		this.swiper = new Swiper(sliderEl, options);

		this.swiper.on('slideChange', () => {
			this.sliderBlockLinks.forEach((linkElement) => {
				const linkElementIndex = parseInt(linkElement.getAttribute('data-slider-block-link'), 10);
				if (this.swiper.activeIndex === linkElementIndex) {
					linkElement.classList.add('is-active');
				} else {
					linkElement.classList.remove('is-active');
				}
			});
		});
	}
}
